module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADZSURBVEhL7ZHLCQIxFEWzEOxAwbU2YQFqGa7syUZECxA/Sy1BrMCNbtR7JJGQec4MGHDhHDgkuQkvP9fwn0zkTl58yzgbFLvLRyTjsczCXsbFg1uZBZ7F2oA8C7y5tUG2G/DW1h+MZBltOffSL4WP5sQ8y0ZWFe/JtQwHok+WhaE8y/jGSMbcV8zkVabFg8yx5k1LTuVScoKbbxmTMx9jFbV8MZBHaS0IHmRfBqw1lq4rT1FQJus6EtK5QCFfJUGVCwlpHijkaVBHsDIo5GlQR7Ay+JQ3/ATnnsZVq/zSJ71LAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-caretaker/dark/24.png
// module id = 1910
// module chunks = 2